export const SENTIMENT_COLOR = {
  NEGATIVE: "#FF306E",
  NEUTRAL: "#DBDA1F",
  POSITIVE: "#27C1BC",
  UNASSIGNED: "#A596D5"
};
